import { geraiRetailMeta } from "../../data/DataMetatags";
import { defBreadcrumb } from "../../data/DataBreadcrumb";
import NextHead from "../../components/Seo/NextHead";
import Layout from "../../components/Layout";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { geraiRetailBreadcrumb } from "../../data/DataBreadcrumb";
import HeadingComponent from "../../components/UserInterface/HeadingComponent";
import GeraiRetailComponent from "../../components/PaymentChannels/GeraiRetail";

const GeraiRetail = (props) => {
  const { breadcrumb, geraiRetailBreadcrumb, title, description, path } = props;
  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={geraiRetailBreadcrumb} />
      <HeadingComponent headingText="Gerai Retail" />
      <GeraiRetailComponent />
    </Layout>
  );
};

export const getStaticProps = () => {
  const { title, description, path } = geraiRetailMeta;

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];
  return {
    props: {
      breadcrumb,
      geraiRetailBreadcrumb,
      title,
      description,
      path
    }
  };
};

export default GeraiRetail;
